import { Component, Input } from '@angular/core';

@Component({
  selector: 'premios-ganados-card',
  templateUrl: 'premios-ganados-card.html'
})
export class PremiosGanadosCardComponent {

  @Input() llaves: number;
  @Input() cofres: number;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/components/premios-ganados-card/premios-ganados-card.ts